import React from 'react';

const RESUME_URLS = {
  fr: '/cv/CV-Saad Beidouri- FR.pdf',
  en: '/cv/CV-Saad Beidouri- EN.pdf',
};

const TECH_STACK = [
  { name: 'Java',        icon: 'devicon-java-plain colored' },
  { name: 'Spring Boot', icon: 'devicon-spring-plain colored' },
  { name: 'TypeScript',  icon: 'devicon-typescript-plain colored' },
  { name: 'React',       icon: 'devicon-react-original colored' },
  { name: 'Next.js',     icon: 'devicon-nextjs-plain' },
  { name: 'Angular',     icon: 'devicon-angularjs-plain colored' },
  { name: 'Docker',      icon: 'devicon-docker-plain colored' },
];

const HIGHLIGHTS = [
  {
    label: 'PlanBoard',
    detail: 'Full-stack teacher dashboard — Spring Boot REST API + Next.js (TypeScript), JWT auth, grade tracking, student action plans.',
  },
  {
    label: 'ProBTP / Abylsen',
    detail: 'Promoted from apprentice to full-stack engineer (CDI). Scope spans monitoring UIs, backend services, and platform observability with Grafana, Prometheus, and Loki.',
  }
];

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="2" y1="7" x2="12" y2="7" />
    <polyline points="8 3 12 7 8 11" />
  </svg>
);

const Hero = () => (
  <section id="about" className="hero-section">
    <div className="container">
      <span className="hero-eyebrow">Full Stack Engineer · ProBTP / Abylsen</span>

      <h1 className="hero-name">
        Saad
        <br />
        <span className="hero-name--last">BEIDOURI</span>
      </h1>

      <p className="hero-description">
        Software engineer graduated from Polytech Nice Sophia (2025), following two years of
        CPGE (MPSI–MP) at Lycée François Rabelais. Currently working as a full-stack engineer
        at ProBTP&nbsp;/&nbsp;Abylsen — building monitoring interfaces, backend services, and
        platform reliability tooling in Java, Spring Boot, Angular, and React.
      </p>

      {/* Tech highlights */}
      <div className="about-stack-row">
        <span className="about-stack-label">Currently working with</span>
        <div className="about-stack-chips">
          {TECH_STACK.map(({ name, icon }) => (
            <span key={name} className="about-stack-chip">
              <i className={icon} aria-hidden="true" />
              {name}
            </span>
          ))}
        </div>
      </div>

      {/* Recent highlights */}
      <div className="about-highlights">
        <span className="about-highlights-label">Recent highlights</span>
        <ul className="about-highlights-list">
          {HIGHLIGHTS.map(({ label, detail }) => (
            <li key={label} className="about-highlights-item">
              <span className="about-highlights-title">{label}</span>
              <span className="about-highlights-detail">{detail}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="hero-ctas">
        <a
          href={RESUME_URLS.fr}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
        >
          Résumé&nbsp;FR <ArrowIcon />
        </a>
        <a
          href={RESUME_URLS.en}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-ghost"
        >
          Résumé&nbsp;EN <ArrowIcon />
        </a>
      </div>
    </div>
  </section>
);

export default Hero;
